import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { AuthResponse, ProfileInfo, RegisterBusinessPayload } from '../types';

export function authEndpoints(http: HttpClient) {
  return {
    login: (email: string, password: string) =>
      http.post<ApiEnvelope<AuthResponse>>('/v1/auth/login', { email, password }).then(unwrap),
    registerBusiness: (payload: RegisterBusinessPayload) =>
      http.post<ApiEnvelope<AuthResponse>>('/v1/auth/register', payload).then(unwrap),
    forgotPassword: (email: string) =>
      http.post<ApiEnvelope<{ message: string }>>('/v1/auth/forgot-password', { email }).then(unwrap),
    resetPassword: (token: string, newPassword: string) =>
      http.post<ApiEnvelope<{ message?: string }>>('/v1/auth/reset-password', { token, newPassword }).then(unwrap),
    switchOrg: (orgId: string) =>
      http.post<ApiEnvelope<AuthResponse>>('/v1/auth/switch-org', { orgId }).then(unwrap),
    meProfiles: () =>
      http.get<ApiEnvelope<ProfileInfo[]>>('/v1/auth/me/profiles').then(unwrap),
  };
}

export type AuthEndpoints = ReturnType<typeof authEndpoints>;
